import {
  FETCH_ALL_PAYMENT,
  FETCH_ALL_PAYMENT_SUCCESS,
  PAYMENT_POPUP_STATUS_CHANGE,
  PAYMENT_BULK_UPDATE_POPUP_STATUS_CHANGE,
  FILTER_PAYMENT,
  FILTER_PAYMENT_SUCCESS,
  SET_PAYMENT,
  UPDATE_PAYMENT,
  UPDATE_PAYMENT_SUCCESS,
  CREATE_PAYMENT,
  CREATE_PAYMENT_SUCCESS,
  UPDATE_BULK,
  UPDATE_BULK_SUCCESS,
  INIT_PAYMENT,
  CHANGE_SELECT_ALL_STATUS,
  ON_CHANGE_UNCHECKED_PAYMENT_LIST,
  ON_CHANGE_PAGE_CHECKED_PAYMENT_LIST,
  ON_CHANGE_NON_SELECT_ALL_CHECKED_PAYMENT_LIST,
} from 'constants/payments.constants'
import { startLoader } from 'actions/general.action';

export const fetchPayments = (page) => {
  return dispatch => {
    dispatch({
      type: FETCH_ALL_PAYMENT,
      payload: page
    })
    dispatch(startLoader())
  }
}
export const fetchPaymentsSuccess = (data) => {
  return {
    type: FETCH_ALL_PAYMENT_SUCCESS,
    payload: data
  };
};

export const filterPayments = (search_key, search_value, search_date, page) => {
  return (dispatch) => {
    dispatch({
      type: FILTER_PAYMENT,
      payload: { key: search_key, value: search_value, date_range: search_date, page: page },
    });
    dispatch(startLoader());
  };
};

export const filterPaymentsSuccess = (data) => {
  return {
    type: FILTER_PAYMENT_SUCCESS,
    payload: data
  };
};
export const openViewPopup = (data) => {
  return {
    type: PAYMENT_POPUP_STATUS_CHANGE,
    payload: data,
  };
};
export const openBulkUpdatePopup = (data) => {
  return {
    type: PAYMENT_BULK_UPDATE_POPUP_STATUS_CHANGE,
    payload: data,
  };
};

export const setPayment = (key, value) => {
  return {
    type: SET_PAYMENT,
    key: key,
    value: value
  }
}
export const updatePayment = (payload) => {
  return {
    type: UPDATE_PAYMENT,
    payload: payload
  };
};
export const updatePaymentSuccess = (data) => {
  return {
    type: UPDATE_PAYMENT_SUCCESS,
    payload: data
  };
};
export const updateBulk = (payload) => {
  return {
    type: UPDATE_BULK,
    payload: payload
  };
};
export const updateBulkSuccess = (data) => {
  return {
    type: UPDATE_BULK_SUCCESS,
    payload: data
  };
};
export const createPayment = (payload) => {
  return dispatch => {
    dispatch({
      type: CREATE_PAYMENT,
      payload: payload
    })
    dispatch(startLoader())
  }
};
export const createPaymentSuccess = (data) => {
  return {
    type: CREATE_PAYMENT_SUCCESS,
    payload: data
  };
};

export const initPayment = (data) => {
  return {
    type: INIT_PAYMENT,
    payload: data
  }
}

export const changeSelectAllStatus = () => {
  return {
    type: CHANGE_SELECT_ALL_STATUS,
  }
}

export const onChangePageCheckedPaymentList = (checked_array) => {
  return {
    type: ON_CHANGE_PAGE_CHECKED_PAYMENT_LIST,
    checked_array: checked_array
  }
}

export const onChangeUncheckedPaymentList = (id) => {
  return {
    type: ON_CHANGE_UNCHECKED_PAYMENT_LIST,
    id: id
  }
}

export const onChangeNonSelectAllcheckedPaymentList = (checked_array) => {
  return {
    type: ON_CHANGE_NON_SELECT_ALL_CHECKED_PAYMENT_LIST,
    checked_array: checked_array
  }
}